import React from 'react'
import UnseenConversationsCountNotification from 'common/components/chat/UnseenConversationsCountNotification'

class MessageNavigation extends React.Component {
  componentDidMount() {
    const fallback = document.getElementById('message-navigation')
    if (fallback) {
      fallback.style.display = 'none'
      $('.unseen_conversation_count').removeClass('hidden');
    }
  }

  render() {
    const { path, linkClass, unseenConversationCount, tailwind } = this.props

    if (tailwind) {
      return (
        <div>
          <div className="font-extrabold leading-6 text-gray-tones-200 text-sm nav-link">
            <a
              className={`${linkClass} hover:bg-base-blue-900 font-bold text-white`}
              href={path}
            >
              Inbox <UnseenConversationsCountNotification unseenConversationCount={unseenConversationCount} />
            </a>
          </div>
        </div>
      )
    }

    return (
      <a className={`btn-block ${linkClass}`} href={path}>
        Inbox <UnseenConversationsCountNotification unseenConversationCount={unseenConversationCount} />
      </a>
    )
  }
}

export default MessageNavigation
